<div class="container mx-auto px-3 py-9">
  <div class="pb-3 text-center">
    <p class="text-4xl font-bold text-primary-darkest">Notification</p>
    <p>You have {{ notification?.totalUnread }} unread notifications</p>
  </div>
  <div class="mx-auto flex justify-center pb-10">
    <button
      (click)="markAllAsRead()"
      class="rounded-lg bg-primary-darkest p-2 hover:-translate-y-1">
      <p class="text-sm text-white">Mark All as Read</p>
    </button>
  </div>

  <!-- Notif -->
  <div class="col-span-12 md:col-span-9">
    <div
      class="mb-3 cursor-pointer rounded border p-4"
      *ngFor="let notif of notification?.notifications"
      [ngClass]="{ 'bg-primary-light': !notif.read_at }"
      [ngSwitch]="notif.data.type"
      (click)="redirect(notif)">
      <div class="card-body grid grid-cols-12">
        <div class="col-span-12" *ngSwitchCase="2">
          <h6 class="title mt-0 mb-1 font-medium">Your order has been sent</h6>
          <p class="mb-2">
            Your order #{{ notif.data.order_id }} It has been sent. <br />Click
            to see your order.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="5">
          <h6 class="title mt-0 mb-1 font-medium">
            Your order has been canceled
          </h6>
          <p class="mb-2">
            Your order #{{ notif.data.order_id }} has been canceled. <br />Click
            to see your order.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="6">
          <h6 class="title mt-0 mb-1 font-medium">
            Your reported order is in process
          </h6>
          <p class="mb-2">
            You have reported your Order #{{ notif.data.order_id }}. <br />Click
            to check your order.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="7">
          <h6 class="title mt-0 mb-1 font-medium">
            Your order has been resolved
          </h6>
          <p class="mb-2">
            Your Order #{{ notif.data.order_id }} has been resolved. <br />Click
            to check your order.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="8">
          <h6 class="title mt-0 mb-1 font-medium">New comment</h6>
          <p class="mb-2">
            There are new comments on product discussion. <br />Click to check.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="9">
          <h6 class="title mt-0 mb-1 font-medium">New beautybook comment</h6>
          <p class="mb-2">
            There are new comments on your beautybook post. <br />Click to check
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="10">
          <h6 class="title mt-0 mb-1 font-medium">New like on your post</h6>
          <p class="mb-2">
            There are new like on your beautybook post. <br />Click to check.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="14">
          <h6 class="title mt-0 mb-1 font-medium">Welcome to Happybeauty</h6>
          <p class="mb-2">
            Verify your email now to get special voucher. <br />Check your email
            now
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="15">
          <h6 class="title mt-0 mb-1 font-medium">Checkout created</h6>
          <p class="mb-2">
            Checkout #{{ notif.data.checkout_id }} has been created.
            <br />Finish your payment now.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="16">
          <h6 class="title mt-0 mb-1 font-medium">Checkout Rejected</h6>
          <p class="mb-2">
            Checkout #{{ notif.data.checkout_id }} has been rejected.
            <br />Contact our customer support for more informations
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="18">
          <h6 class="title mt-0 mb-1 font-medium">
            Happy Pay top-up confirmed
          </h6>
          <p class="mb-2">
            Happy Pay top-up #{{ notif.data.happy_pay_top_up_id }} confirmed.
            <br />Click to check
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="19">
          <h6 class="title mt-0 mb-1 font-medium">Happy Pay top-up rejected</h6>
          <p class="mb-2">
            Happy Pay top-up #{{ notif.data.happy_pay_top_up_id }} rejected.
            <br />Click to check
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="21">
          <h6 class="title mt-0 mb-1 font-medium">
            Happy Pay withdrawal confirmed
          </h6>
          <p class="mb-2">
            Happy Pay withdrawal #{{
              notif.data.happy_pay_top_up_id
            }}
            confirmed. <br />Click to check
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="22">
          <h6 class="title mt-0 mb-1 font-medium">
            Happy Pay withdrawal rejected
          </h6>
          <p class="mb-2">
            Happy Pay withdrawal #{{ notif.data.happy_pay_top_up_id }} rejected.
            <br />Click to check.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="23">
          <h6 class="title mt-0 mb-1 font-medium">New HappyPay Adjustment</h6>
          <p class="mb-2">
            We have adjusted your HappyPay balance. <br />Click to check.
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchCase="24">
          <h6 class="title mt-0 mb-1 font-medium">Thanks for your payment</h6>
          <p class="mb-2">
            Checkout #{{ notif.data.checkout_id }} has been paid. <br />We will
            proceed your order right away
          </p>
          <small>{{ notif.timeStamp }}</small>
        </div>
        <div class="col-span-12" *ngSwitchDefault>
          <h6 class="title mt-0 mb-1 font-medium"></h6>
          <p class="mb-2"></p>
          <small>{{ notif.timeStamp }}</small>
        </div>
      </div>
    </div>
  </div>
</div>
